var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Cartographic, Ellipsoid } from '@skand/math';
import * as XLSX from 'xlsx';
export class SapLoader {
    /**
     * Convert a position in some coordinate system to ECEF
     *
     * @param x          x-position in source coordinate system
     * @param y          y-position in source coordinate system
     * @param z          z-position in source coordinate system
     */
    calculatePosition(x, y, z) {
        return Ellipsoid.WGS_84.cartesianForCartographic(new Cartographic((x * Math.PI) / 180, (y * Math.PI) / 180, z));
    }
    /**
     * Convert DD/MM/YYYY to MM/DD/YYYYY
     *
     * @param dateStr
     */
    formatDate(dateStr) {
        const [day, month, year] = dateStr.split('/');
        const date = new Date(`${year}-${month}-${day}`);
        const formattedDate = date
            .toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        })
            .split('/')
            .join('/');
        return formattedDate;
    }
    /**
     * Get Fields
     *
     * @param row
     * @param tempfield
     */
    getField(row, tempfield) {
        switch (tempfield.type) {
            case 'DATE':
                return {
                    name: tempfield.name,
                    type: tempfield.type,
                    value: this.formatDate(row[tempfield.name]),
                };
            default:
                return {
                    name: tempfield.name,
                    type: tempfield.type,
                    value: row[tempfield.name],
                };
        }
    }
    /**
     * Get list of annotations
     *
     * @param buffer xlsx string
     * @param templateFields template fields array
     */
    read(buffer, templateFields) {
        return __awaiter(this, void 0, void 0, function* () {
            const workbook = XLSX.read(buffer, { type: 'array' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const annotations = [];
            // Convert the sheet to JSON with default values as empty strings
            const rows = XLSX.utils.sheet_to_json(sheet, {
                defval: '',
                raw: false,
            });
            for (let i = 0; i < rows.length; i++) {
                const name = rows[i]['Functional Loc.'] || `Annotation-${i}`;
                const annotationFields = [];
                for (const tempfield of templateFields) {
                    if (rows[i][tempfield.name] !== undefined) {
                        const field = this.getField(rows[i], tempfield);
                        annotationFields.push(field);
                    }
                }
                annotations.push({
                    name: name,
                    color: '#FFFFFF',
                    annotation3d: {
                        positions: [
                            this.calculatePosition(rows[i]['Longitude'], rows[i]['Latitude'], 0),
                        ],
                        shapeType: 'POINT',
                    },
                    fields: annotationFields,
                });
            }
            return annotations;
        });
    }
}
